export const createUser = (payload) => (dispatch) => {
  dispatch({
    type: 'CREATE_USER',
    payload,
  });
};

export const resetUser = (payload) => (dispatch) => {
  dispatch({
    type: 'RESET_USER',
    payload,
  });
};

export const updateUser = (payload) => (dispatch) => {
  dispatch({
    type: 'UPDATE_USER',
    payload,
  });
};
